import React, {useMemo, useState} from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, parseSettingsToData, Settings } from '../../Components/Form';
import { customerNotificationSettings, useSettings } from '../../Data/Settings';
import { PageLoading } from '../../Components/Loading';

const Notifications = ({customer, isOpen, setIsOpen}) => {
    return <Modal title="Customer Notifications" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner {...{customer}} />}
    </Modal>
}

const Inner = ({customer}) => {
    const {settings, update, isLoading} = useSettings(
        'notifications/settings',
        'Notifications saved',
        {customerId: customer.id, default: false}
    );
    const [adding, setAdding] = useState([]);

    const saveNotifications = (data) => {
        const toSave = customerNotificationSettings.reduce((toSave, setting) => {
            if (data[setting] === '') {
                toSave[setting] = 'remove';
            } else if (data[setting]) {
                toSave[setting] = data[setting];
            }
            return toSave;
        }, {});

        return update(toSave);
    }

    const activeSettings = useMemo(() => {
        if (!settings) {
            return [];
        }
        return customerNotificationSettings
            .filter(setting => (settings.find(s => s.key === setting)?.value ?? false) || adding.includes(setting));
    }, [settings, adding]);

    if (!settings || isLoading) {
        return <PageLoading />;
    }

    return <Form data={parseSettingsToData(settings)} onSubmit={saveNotifications} closeModalOnSubmit>

        <AddSetting {...{settings, adding, setAdding}} />

        <hr className="my-3" />

        {activeSettings.length === 0 && <p className="my-5 mx-auto w-[80%] text-center text-muted text-sm text-balance">
            No custom notification settings for this customer.<br /><br />
            All notifications will use the default settings.
        </p>}

        <Settings settings={settings} filter={activeSettings} unselected="Use defaults" />

        <Actions submit={{label: 'Update'}} cancel />
    </Form>
}

const AddSetting = ({settings, adding, setAdding}) => {
    const notActiveSettings = useMemo(() => {
        if (!settings) {
            return [];
        }
        return customerNotificationSettings
            .filter(setting => !(settings.find(s => s.key === setting)?.value ?? false) && !adding.includes(setting))
            .map(setting => ({
                value: setting,
                label: settings.find(s => s.key === setting).label,
            }));
    }, [settings, adding]);

    return <div className="w-full p-2 bg-blue-50 rounded-lg ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-brand">
        <select
            key={JSON.stringify(notActiveSettings)}
            className="w-full rounded-lg bg-white border border-gray-300 text-gray-900 sm:text-sm sm:leading-6 outline-none focus:outline-none focus:ring-0 focus:border-gray-300"
            onChange={(e) => {
                setAdding([...adding, e.target.value])
                e.target.blur();
                e.target.value = '';
            }}
        >
            <option value="">Add a notification</option>

            {notActiveSettings.map((option, index) => {
                return <option key={index} value={option.value}>{option.label}</option>
            })}
        </select>
    </div>
}

export default Notifications;
